import { useSelector } from 'react-redux'

import Loader from '../../shared/Loader'
const JwtHandler = (props) => {
  const { children } = props
  const jwt = useSelector((state) => state.auth.jwt)
  if (jwt) {
    return children
  } else {
    return <Loader />
  }
}

export default JwtHandler
